import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { UserContext } from '../context/User';
import { buildNavItems } from './nav-items';
import { isAdmin, isRoot } from '../helpers';
import './Sidebar.css';

const Sidebar = ({ open = false, onNavigate = () => {} }) => {
  const { t } = useTranslation();
  const [userState] = useContext(UserContext); // re-render when the user logs in/out
  const items = buildNavItems({ isAdmin: isAdmin(), isRoot: isRoot(), loggedIn: !!userState.user });
  const main = items.filter((i) => i.group === 'main');
  const system = items.filter((i) => i.group === 'system');

  const renderItem = (item) => (
    <NavLink
      key={item.to}
      to={item.to}
      onClick={onNavigate}
      className={({ isActive }) => 'pz-navitem' + (isActive ? ' active' : '')}
    >
      <Icon name={item.icon} /> {t(item.nameKey)}
    </NavLink>
  );

  return (
    <nav className={'pz-sidebar' + (open ? ' open' : '')}>
      <NavLink to='/' className='pz-brand' onClick={onNavigate} aria-label='Proteales AI'>
        <img src='/proteales-logo.png' alt='Proteales' width='122' height='25' />
        <span className='pz-brand-tag'>AI</span>
      </NavLink>
      {main.map(renderItem)}
      {system.length > 0 && <div className='pz-group-label'>{t('nav.system')}</div>}
      {system.map(renderItem)}
    </nav>
  );
};

export default Sidebar;
